module.exports = __webpack_public_path__ + "static/media/mp3.c5a0b9c4.png";